import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Label, Select } from 'features/ui/elements';
import styled from 'features/theme/styled';
import { useHearings } from 'features/call/call-hearing/hooks';
import { maskPhoneNumber } from 'features/phone-number/helpers';

interface DialPadParticipantSelectProps {
  onParticipantSelected: (id: string | null) => void;
  value: string | null;
}

export const DialPadParticipantSelect = ({
  value,
  onParticipantSelected,
}: DialPadParticipantSelectProps) => {
  const { t } = useTranslation();
  const { activeHearings } = useHearings();

  const options = useMemo(
    () =>
      activeHearings.map((hearing) => ({
        value: hearing.id,
        text: maskPhoneNumber(hearing.phoneNumber),
      })),
    [activeHearings]
  );

  if (options.length < 2) {
    return null;
  }

  return (
    <Container>
      <Label text={t('selectHearingCallee')} />
      <Select
        data-testid='dialpad-participant-select'
        options={options}
        value={value}
        onChange={(event) =>
          onParticipantSelected(event.target.value as string | null)
        }
      />
    </Container>
  );
};

const Container = styled('div')`
  width: 266px;
`;
